module.exports = __webpack_public_path__ + "static/img/charm_level_85.5a11627.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/level/charm_level_85.png
// module id = pq2W
// module chunks = 0